import React from "react"
import PropTypes from "prop-types"

import Sponsor from "../Sponsor/Sponsor"
import styles from "./Footer.module.scss"

const Footer = ({ sponsorLogo, height }) => (
    <div className={styles.footerContainer}>
        <Sponsor height={height} sponsorLogo={sponsorLogo} />
    </div>
)

Footer.propTypes = {
    sponsorLogo: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
}

export default Footer
